export default class Equipe {
    score = {
        contre: null,
        joueurs: null
    };
    dataJoueurs = {
        joueurs: {
            J1: null,
            J2: null,
            J3: null
        },
        contre: {
            J1:null,
            J2: null,
            J3: null
        }
    };
    pool= null;
    state="WAITING";
    getJson() {
       var equipeJson = {
            joueurs: {
                J1: {numero: this.dataJoueurs.joueurs.J1, error: false, errorDetail: {}, parties: []},
                J2: null,
                J3: null
            },
            contre: {
                J1: {numero: this.dataJoueurs.contre.J1, error: false, errorDetail: {}, parties: []},
                J2: null,
                J3: null
            },
            state: this.state,
            score: {
                contre : this.score.contre,
                joueurs : this.score.joueurs
            },
            pool: this.pool
        }
        return equipeJson;
    }
    random(min, max) {
        return Math.floor(min + Math.random() * (max - min));
    }
    constructor (options, pool) {
        this.options = options;
        if (typeof(pool)!="undefined")
            this.pool = pool;
    }
    findNumero(numero, listNumeros, historiqueJoueurs) {
        if (listNumeros.length==0)
            return null;
        else {
            var indexNumero = this.random(0,listNumeros.length);
            var numeroFind = listNumeros[indexNumero];
            if (typeof(historiqueJoueurs[numero])!="undefined") {
                if (historiqueJoueurs[numero].indexOf(numeroFind) == -1)
                    return numeroFind;
                else {
                    var listNumerosBis = listNumeros.slice();
                    return this.findNumero(numero, listNumerosBis, historiqueJoueurs);
                }
            }
            else
                return numeroFind;
        }
    }
    initHisto(historiqueJoueurs) {
        if (typeof(historiqueJoueurs[this.dataJoueurs.joueurs.J1]) == "undefined")
            historiqueJoueurs[this.dataJoueurs.joueurs.J1] = [];
        if (typeof(historiqueJoueurs[this.dataJoueurs.contre.J1]) == "undefined")
            historiqueJoueurs[this.dataJoueurs.contre.J1] = [];
        historiqueJoueurs[this.dataJoueurs.joueurs.J1].push(this.dataJoueurs.contre.J1);
        historiqueJoueurs[this.dataJoueurs.contre.J1].push(this.dataJoueurs.joueurs.J1)
    }
    init ( listNumeros, historiqueJoueurs) {
        var indexNumero = this.random(0,listNumeros.length);
        var numero = listNumeros[indexNumero];
        this.dataJoueurs.joueurs.J1 = numero;
        listNumeros.splice(indexNumero, 1);
        if (listNumeros.length>0) {
            var numeroContre = this.findNumero(numero, listNumeros, historiqueJoueurs);
            this.dataJoueurs.contre.J1 = numeroContre;
            var indexContre = listNumeros.indexOf(numeroContre);
            listNumeros.splice(indexContre, 1);
        }
        if (this.dataJoueurs.contre.J1!=null) {
            if (typeof(historiqueJoueurs[this.dataJoueurs.joueurs.J1]) == "undefined")
                historiqueJoueurs[this.dataJoueurs.joueurs.J1] = [];
            if (typeof(historiqueJoueurs[this.dataJoueurs.contre.J1]) == "undefined")
                historiqueJoueurs[this.dataJoueurs.contre.J1] = [];
            historiqueJoueurs[this.dataJoueurs.joueurs.J1].push(this.dataJoueurs.contre.J1);
            historiqueJoueurs[this.dataJoueurs.contre.J1].push(this.dataJoueurs.joueurs.J1)
        }
        else {
            this.score["joueurs"] = 13;
            this.score["contre"] = 7;
            this.state="FINISH";
        }
    }
}